import { types } from "../types/types";
const intitalState = {
    userProfile: {},
    loaded: false,
};

const profileReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.USER_DETAIL:
            return {
                ...state,
                userProfile: action.payload,
                loaded: true,
            };
        default:
            return { ...state };
    }
};

export default profileReducer;
